/**
 * Saves booking form data as line item properties (with _ prefix so hidden at checkout)
 * on each product that requires booking (e.g. Samtaletrening). Store owner sees each product's
 * form data as attributes of that line item on the order.
 */
(function () {
  var ATTR_PREFIX = 'attributes[';
  var BOOKING_KEYS = ['Course language', 'Best time for talks', 'Preferred start date', 'Additional information'];

  function getBookingValuesFromForm(form) {
    var container = form.querySelector('.cart-booking-fields');
    var scope = container || form;
    var values = {};
    BOOKING_KEYS.forEach(function (key) {
      var name = ATTR_PREFIX + key + ']';
      var input = scope.querySelector('input[name="' + name + '"], textarea[name="' + name + '"]');
      if (!input) return;
      if (input.type === 'radio') {
        var checked = scope.querySelector('input[name="' + name + '"]:checked');
        values[key] = checked ? checked.value : '';
      } else {
        values[key] = input.value || '';
      }
    });
    return values;
  }

  function lineItemNeedsCallTime(item) {
    var handle = (item.handle || '').toLowerCase();
    var title = (item.product_title || item.title || '').toLowerCase();
    return handle === 'samtaletrening'
      || handle.indexOf('a2-b1-muntlig') !== -1
      || handle.indexOf('b1-b2-muntlig') !== -1
      || handle.indexOf('a2-oral') !== -1
      || handle.indexOf('conversation-training') !== -1
      || title.indexOf('conversation training in norwegian') !== -1
      || title.indexOf('samtaletrening') !== -1
      || title.indexOf('pass the a2 oral') !== -1
      || title.indexOf('a2 oral norwegian exam') !== -1
      || title.indexOf('note a2-b1 muntlig') !== -1
      || title.indexOf('note b1-b2 muntlig') !== -1;
  }

  function lineItemIsFreeCourse(item) {
    var handle = (item.handle || '').toLowerCase();
    var title = (item.product_title || item.title || '').toLowerCase();
    return handle.indexOf('free-norwegian-course') !== -1
      || handle.indexOf('gratis-norskkurs') !== -1
      || title.indexOf('free norwegian course for all levels') !== -1
      || title.indexOf('gratis norskkurs for alle niv') !== -1;
  }

  function lineItemNeedsBooking(item) {
    return lineItemNeedsCallTime(item) || lineItemIsFreeCourse(item);
  }

  function buildLineItemProperties(bookingValues) {
    var props = {};
    Object.keys(bookingValues).forEach(function (key) {
      props['_' + key] = String(bookingValues[key]);
    });
    return props;
  }

  function setupForm(form) {
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter || (typeof e.originalEvent !== 'undefined' && e.originalEvent.submitter);
      if (!submitter || submitter.getAttribute('name') !== 'checkout') return;

      var bookingValues = getBookingValuesFromForm(form);
      if (Object.keys(bookingValues).length === 0) return;

      e.preventDefault();

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      function goToCheckout() {
        window.location.href = root + 'checkout';
      }

      fetch(root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var itemsToUpdate = (cart.items || []).filter(lineItemNeedsBooking);
          if (itemsToUpdate.length === 0) {
            goToCheckout();
            return;
          }
          var newProps = buildLineItemProperties(bookingValues);
          var i = 0;
          function runNext() {
            if (i >= itemsToUpdate.length) {
              goToCheckout();
              return;
            }
            var item = itemsToUpdate[i];
            i += 1;
            var merged = {};
            if (item.properties && typeof item.properties === 'object') {
              Object.keys(item.properties).forEach(function (k) { merged[k] = item.properties[k]; });
            }
            Object.keys(newProps).forEach(function (k) { merged[k] = newProps[k]; });
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties: merged
              })
            })
              .then(function (res) { return res.json(); })
              .then(function () { return runNext(); })
              .catch(function () { return runNext(); });
          }
          return runNext();
        })
        .catch(function () {
          goToCheckout();
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="/cart"]');
    forms.forEach(setupForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart-drawer:refreshed', init);
})();
